export default {
    cn: {
        header: {
            hello: '你好',
            userName: '欢迎使用交易报表系统',
            language: '简体中文',
            adminSuperuser: {
                text: '管理超级用户',
                list: {
                    logOut: '登出'
                }
            }
        }
    },
    hk: {
        header: {
            hello: '你好',
            userName: '歡迎使用交易報表系統',
            language: '繁體中文',
            adminSuperuser: {
                text: '管理超級用戶',
                list: {
                    logOut: '登出'
                }
            }
        }
    },
    en: {
        header: {
            hello: 'hello',
            userName: 'Welcome to the dealing report engine',
            language: 'English',
            adminSuperuser: {
                text: 'adminSuperuser',
                list: {
                    logOut: 'logOut'
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/header.js